import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import { reducer as ManualReducer } from '../modules/Manual';

export const createRootReducer = (history: any) => {
  return combineReducers({
    router: connectRouter(history),
    manual: ManualReducer
  });
};
